import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MessageModule} from 'primeng/message';
import {MessagesModule} from 'primeng/messages';
import {CardModule} from 'primeng/card';
import {DropdownModule} from 'primeng/dropdown';
import {InputTextModule} from 'primeng/inputtext';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {ButtonModule} from 'primeng/button';
import {TabViewModule} from 'primeng/tabview';
import {InputMaskModule} from 'primeng/inputmask';
import {RadioButtonModule} from 'primeng/radiobutton';
import {PickListModule} from 'primeng/picklist';
import {CheckboxModule} from 'primeng/checkbox';
import {CalendarModule} from 'primeng/calendar';
import {ToastModule} from 'primeng/toast';
import {TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import {DialogModule} from 'primeng/dialog';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {BadgeModule} from 'primeng/badge';

import {MapaCoreModule} from '@mapa/core';
import {LoadingModule} from './core/loading/loading.module';
import {LoaderModule} from './core/loader/loader.module';
import {BooleanPipe} from './pipe/boolean.pipe';
import {CpfCnpjPipe} from './pipe/cpf-cnpj.pipe';
import {TelefonePipe} from './pipe/telefone.pipe';
import {UploadComponent} from './components/upload/upload.component';
import {ManterEmailComponent} from './components/manter-email/manter-email.component';
import {ManterTelefoneComponent} from './components/manter-telefone/manter-telefone.component';
import {ManterEnderecoComponent} from './components/manter-endereco/manter-endereco.component';


@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MapaCoreModule,

        BadgeModule,
        CardModule,
        DialogModule,
        MessageModule,
        MessagesModule,
        DynamicDialogModule,
        ConfirmDialogModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        AutoCompleteModule,
        ButtonModule,
        TabViewModule,
        InputMaskModule,
        RadioButtonModule,
        PickListModule,
        CheckboxModule,
        CalendarModule,
        TooltipModule,
        ToastModule,
        TableModule,

        LoadingModule,
        LoaderModule
    ],
    declarations: [
        BooleanPipe,
        CpfCnpjPipe,
        TelefonePipe,
        UploadComponent,
        ManterEmailComponent,
        ManterTelefoneComponent,
        ManterEnderecoComponent
    ],
    exports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MapaCoreModule,

        BadgeModule,
        MessageModule,
        MessagesModule,
        DialogModule,
        DynamicDialogModule,
        ConfirmDialogModule,
        CardModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        AutoCompleteModule,
        ButtonModule,
        TabViewModule,
        InputMaskModule,
        RadioButtonModule,
        PickListModule,
        CheckboxModule,
        CalendarModule,
        TooltipModule,
        ToastModule,
        TableModule,

        LoadingModule,
        LoaderModule,

        BooleanPipe,
        CpfCnpjPipe,
        TelefonePipe,
        UploadComponent,
        ManterEmailComponent,
        ManterTelefoneComponent,
        ManterEnderecoComponent
    ]
})
export class SharedModule {
}
